export enum AdditionalAssessmentsConstants {
  SET_ASSESSMENTS_SEQUENCE = 'AdditionalAssessments/SET_ASSESSMENTS_SEQUENCE',
  SET_SELECTED_ASSESSMENT = 'AdditionalAssessments/SET_SELECTED_ASSESSMENT',
  SET_BODY_SURVEY_ASSESSMENT_LIST = 'AdditionalAssessments/SET_BODY_SURVEY_ASSESSMENT_LIST',
  SET_ASSESSMENT_SUMMARY_DATE = 'AdditionalAssessments/SET_ASSESSMENT_SUMMARY_DATE',
  SET_ASSESSMENT_SUMMARY_UPDATED_FINDING = 'AdditionalAssessments/SET_ASSESSMENT_SUMMARY_UPDATED_FINDING',
  DELETE_ASSESSMENT = 'AdditionalAssessments/DELETE_ASSESSMENT',
  DELETE_SUMMARY_EXAM_OPTION = 'AdditionalAssessments/DELETE_SUMMARY_EXAM_OPTION',
  RESET_ASSESSMENTS = 'AdditionalAssessments/REST_ASSESSMENTS',
  RESET_SELECTED_ASSESSMENT = 'AdditionalAssessments/RESET_SELECTED_ASSESSMENT',
  OBSTETRICS = 'obstetrics',
  DRAINS_AND_TUBES = 'drainsAndTubes',
}
